import { useRef, useState } from "react";
import { useParams } from "react-router-dom"
import { useMutation, useQuery} from "react-query";
import Service from "../../Service/http";
import Pagination from "@mui/material/Pagination";
import {ClipLoader, FadeLoader} from 'react-spinners';
import {toast} from 'react-toastify'
import {FaCloudUploadAlt, FaFileUpload, FaHistory} from 'react-icons/fa';
import {GrPowerReset} from 'react-icons/gr'
import * as xlsx from "xlsx";
import { FaDownload } from "react-icons/fa";
import { Link } from "react-router-dom";
import { toDateTimeLocalFormat } from "../../Utils/UtilityFunctions";

export default function BatchDetails() {

    const params = useParams();
    const  [batchName] = useState(params.batchName);
    const [selectedCriteria, setSelectedCriteria] = useState('')
    const [startTime, setStartTime] = useState('');
    const [endTime, setEndTime] = useState('');
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [selectedUsers, setSelectedUsers] = useState([])
    const [limit, setLimit] = useState(10)
    const [totalDocs, setTotalDocs] = useState(0)
    const [file, setFile] = useState(null)

    const inputRef = useRef();
    const service = new Service();

    const handleChange = (member) => {
        setSelectedUsers((prevUsersState) => {
            if(prevUsersState.some((user) => user.email === member.email)) {
                return prevUsersState.filter((user) => user.email !== member.email)
            } else {
                return [...prevUsersState, {email: member.email, action : 'remove'}]
            }
        })
    }

    const {
      data,
      refetch: refetchBatchData,
      isLoading: loading,
    } = useQuery(
      ["batchUsers", page, limit],
      () =>
        service.get(
          `api/users/batch/${batchName}/?page=${page}&limit=${limit}`
        ),
      {
        onSuccess(json) {
          setTotalPages(json.totalPage);
          setTotalDocs(json.totalDocs);
        },
        refetchOnWindowFocus: false,
      }
    );

    const handlePageChange = (e, v) => {
        setPage(v);
    }

    const handleSelectAll = () => {
        if(inputRef.current.checked){ 
            const allUsers = data?.batch_users?.map((member) => {
                return {
                    email: member.email, action: 'remove'
                }
            });
            setSelectedUsers(allUsers)
        }
        else setSelectedUsers([])
    }

    const generateOptions = () => {
        const options = [];
        const totalLimit = Math.ceil(totalDocs/10)+1;
        for(let i=1; i<totalLimit; i++) {
            options.push(i * 10)
        }
        return options;
    }

    const handleAddOrRemoveUsers = async (action) => {
        service.put(`api/users/batch/${batchName}`, {
            users: action === 'remove' ? selectedUsers : file
        }).then((response) => {
            setSelectedUsers([])
            setFile(null);
            refetchBatchData();
            toast.success("Updated")
        }).catch(error => {
            toast.error(error)
            console.log(error)
            setSelectedUsers([])
            setFile(null)
        }) 
    }

    const getBatchDetails = async () => {

        const response = await service.get(`api/batch/details?batchName=${batchName}`)
        return response;

    }

    const { data : batchData } = useQuery(['batchDetails'], getBatchDetails, {
        onSuccess(json) {
            setSelectedCriteria(json.data.criteria_name)
            setStartTime(toDateTimeLocalFormat(new Date(json.data.startTime)));
            setEndTime(toDateTimeLocalFormat(new Date(json.data.endTime)));
        },
        onError(json) {
            toast.error('Unable to get batch details');
        },
        refetchOnWindowFocus: false
    });

    const { data: criteriaOptions } = useQuery(["criteria" ], () =>
        service.get("api/all/criteria").then((response) => response)
    );

    const updateBatch = async () => {
        const response = await service.put('api/updateBatch', { criteria : selectedCriteria, startTime, endTime, batch_id : batchData?.data?._id });
        return response;
    }

    const { mutate, isLoading: updationLoading } = useMutation(['updateBatch'], updateBatch, {
        onSuccess(json) {
            toast.success(json.message);
        },
        onError(error) {
            console.error(error);
            toast.error("Some Error Occurred!");
        },
    })

    const handleBatchUpdate = () => {

        if(!selectedCriteria || !startTime || !endTime) {
            toast.error('Please Fill The Mandatory Fields')
            return;
        }

        if(new Date(startTime) > new Date(endTime)) {
            toast.error('Start Time Must Be Greater Than End Time');
            return;
        }

        mutate();

    }
    // utility functions

    const handleFileUpload = (e) => {
        try{
            if (e && e.target && e.target.files && e.target.files[0]) {
            const reader = new FileReader();
            reader.onload = (e) => {
                const data = e.target.result;
                const workbook = xlsx.read(data, { type: "array" });
                const sheetName = workbook.SheetNames[0];
                const worksheet = workbook.Sheets[sheetName];
                const json = xlsx.utils.sheet_to_json(worksheet);
                setFile(json)
                console.log(json)
            };
            reader.readAsArrayBuffer(e.target.files[0]);
            }
        }
        catch(err){
            console.log(err);
        }
    };

    const rows = data?.batch_users?.map((member) => {
        return <tr className="text-center" key={member._id}>
            <td className="font-weight-bold">
                {member.roll_number ? member.roll_number : 'N/A'}
            </td>
            <td>
                {member.name ? member.name.slice(0, 19).toUpperCase() : ''}
            </td>
            <td>
                {member.email ? member.email : ''}
            </td>
            <td>
                <input 
                type="checkbox" style={{height: '20px', width: '20px'}}
                onChange={(e) => {
                   handleChange(member)
                }}
                checked={selectedUsers.length > 0 && selectedUsers.some((user) => user.email === member.email)}
                />
            </td>
        </tr>
    });

    const options = generateOptions().map((value) => {
        return <option value={value}>{value}</option>
    })
    
return (
    !loading ? (
        <>

        <div className="container justify-right d-flex justify-content-end align-items-center rounded mt-2 bg-secondary" style={{height: '50px'}}>
            <div className="container d-flex justify-content-between">
            <Link
                className="float-start mb-2"
                to="/files/SampleUserBatchUpdate.xlsx"
                target="_blank"
                download
            >
            {" "}
            <FaDownload /> Download Sample{" "}
            </Link>

                {!file && <label htmlFor="upload-file" style={{cursor: 'pointer'}} className="text-primary">
                    <FaFileUpload size={22}/>
                    <span className="mx-2">Upload File</span>
                    <input type="file" id="upload-file" style={{display: 'none'}} onChange={(e) => handleFileUpload(e)}/>
                </label>
                }
                <Link to={`/admin/batch/history/${batchName}`}><FaHistory/> History</Link>
            </div>
            {
                file && 
                <button
                    className="custom-button mx-2"
                    style={{backgroundColor: 'transparent'}}
                    onClick={()=> setFile(null)}
                >
                <GrPowerReset/>
                </button>
            }
            {
            file && 
                <button 
                className="custom-button border" 
                style={{backgroundColor: 'transparent', width: '150px'}}
                data-toggle="tooltip" data-placement="right"
                title="Upload File"
                onClick={() => handleAddOrRemoveUsers('update')}
                >
                    <FaCloudUploadAlt color="black" size={25}/>
                    <span className="text-black mx-2">Upload</span>
                </button>
            }
        </div>

        <h2 className="text-center text-primary my-3">{batchName}</h2>

        {/* Batch Edit Container */}
        
        <div className="container my-2">
            <div className="batchEdit d-flex flex-wrap">
                <div className="w-50 p-2">
                    <label htmlFor="batchName">Batch Name</label>
                    <input type="text" value={batchName} id="batchName" className="form-control batchName" disabled/>
                </div>
                <div className="w-50 p-2">
                    <label htmlFor="criteria">Criteria <span className="text-danger">*</span></label>
                    <select id="criteria" className="form-select" value={selectedCriteria} onChange={(e) => setSelectedCriteria(e.target.value)}>
                        {
                            criteriaOptions && criteriaOptions.map((criteria) => {
                                return <option value={criteria}>{criteria}</option>
                            })
                        }
                    </select>
                </div>
                <div className="w-50 p-2">
                    <label htmlFor="batchName">Start Time <span className="text-danger">*</span></label>
                    <input type="datetime-local" id="batchName" className="form-control batchName" onChange={(e) => setStartTime(e.target.value)} value={startTime}/>
                </div>
                <div className="w-50 p-2">
                    <label htmlFor="batchName">End Time <span className="text-danger">*</span></label> 
                    <input type="datetime-local" id="batchName" className="form-control batchName" onChange={(e) => setEndTime(e.target.value)}  value={endTime}/>
                </div>
                <div className="w-100 d-flex justify-content-end p-2">
                    <button 
                        className="bg-success custom-button d-flex justify-content-center align-items-center"
                        onClick={handleBatchUpdate}
                        style={{ minWidth: 50, minHeight: 35}}
                    >
                        {updationLoading ? <ClipLoader size={20} color="white"/> : "Update"}
                    </button>
                </div>
            </div>
        </div>

        <h4 className="text-center mt-2 text-primary text-decoration-underline">BATCH USERS</h4>

        {/* Batch Users Table */}
        <div className="batch-user-container container my-3">
            <div className="overflow-scroll">
            <table className="table table-striped table-bordered">
                <thead className="thead-dark">
                    <tr className="text-center">
                        <th>R.No</th>
                        <th>Name</th>
                        <th>Email</th>
                        <th style={{display: 'flex', justifyContent:'center', alignItems: 'center'}}>
                            Select All
                            <input 
                            type="checkbox" 
                            className="mx-2" 
                            style={{height: '15px', width: '15px'}}
                            onChange={handleSelectAll}
                            ref={inputRef}
                            />
                            
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {
                        rows
                    }
                </tbody>
            </table>
            </div>
        </div>
        <div className="container d-flex justify-content-between">

            <select 
                    className="custom-select" 
                    style={{width: '4rem', height: '2rem', borderRadius: '5px', border: '1px solid gray', outline: 'none', textAlign: 'center'}}
                    onChange={(e) => {
                        setLimit(e.target.value)
                        setPage(1)
                        if(inputRef.current.checked) {
                            setSelectedUsers([])
                            inputRef.current.checked = false;
                        }
                        }
                    }
                    value={limit}
                    >
                        {
                            options
                        }
                </select>
                <Pagination
                    count={totalPages}
                    color="primary"
                    defaultPage={1}
                    page={page}
                    onChange={handlePageChange}
                    variant="outlined" shape="rounded"
                />
                <button 
                className="custom-button" style={{backgroundColor: selectedUsers.length > 0 ? 'rgb(233 83 83)' : '#a4a4a4'}} 
                disabled={selectedUsers.length === 0}
                onClick={() => handleAddOrRemoveUsers('remove')}
                >
                    Remove Users
                </button>

      </div>
        </>
    ) : <div className="d-flex w-100 justify-content-center align-items-center" style={{height: '90vh'}}>
            <FadeLoader />
        </div>
    )
}